import React from 'react';
import { Shield, Mail, Phone, MapPin, ExternalLink } from 'lucide-react';
import '../styles/Footer.css';
import { Link } from 'react-router-dom';
import { getFeaturedPrograms } from '../data/trainingData';

const Footer = () => {
  const CurrentDate = new Date();

  return (
    <footer className="footer-enterprise">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-brand">
            <div className="footer-logo">
              <img title="Edsy Tech logo" className="logo" alt="Logo" src="/images/website.png"></img>
            </div>
            <p className="footer-description">
              Enterprise SaaS architecture and long-term ownership partner. We run and maintain
              the business-critical systems .NET-first platforms depend on—not just the servers—
              backed by 99.9% uptime and board-ready documentation.
            </p>
            <div className="footer-trust-badges">
              <div className="trust-badge">99.9% System Uptime</div>
              <div className="trust-badge">24/7 System Ownership</div>
              <div className="trust-badge">10+ Years Experience</div>
            </div>
          </div>

          <div className="footer-links-section">
            <h4 className="footer-links-title">Solutions</h4>
            <div className="footer-links">
              <a href="#solutions" className="footer-link">Architecture & Build</a>
              <a href="#solutions" className="footer-link">Cloud & DevOps</a>
              <a href="#solutions" className="footer-link">Data & Performance</a>
              <a href="#solutions" className="footer-link">Reliability & Compliance</a>
            </div>
          </div>

          <div className="footer-links-section">
            <h4 className="footer-links-title">AI Products</h4>
            <div className="footer-links">
              <Link to="/products" className="footer-link">Products Overview</Link>
              <a
                href="https://snippy.live/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link footer-link-external"
              >
                Snippy
                <ExternalLink className="external-icon" />
              </a>
              <a
                href="https://www.sesslink.com/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link footer-link-external"
              >
                Sesslink
                <ExternalLink className="external-icon" />
              </a>
            </div>
          </div>

          <div className="footer-links-section">
            <h4 className="footer-links-title">Training & Internship</h4>
            <div className="footer-links">
              <Link to="/training" className="footer-link">All Training Programs</Link>
              {getFeaturedPrograms().map((program) => (
                <Link key={program.slug} to={`/training/${program.slug}`} className="footer-link">
                  {program.title.replace(' Training & Internship', '')}
                </Link>
              ))}
            </div>
          </div>

          <div className="footer-links-section">
            <h4 className="footer-links-title">Company</h4>
            <div className="footer-links">
              <a href="#portfolio" className="footer-link">Portfolio</a>
              <a href="#insights" className="footer-link">Insights</a>
              <Link to="/blog" className="footer-link">Blog</Link>
              <a href="#contact" className="footer-link">Contact</a>
              <a
                href="https://www.upwork.com/agencies/edsytech/"
                target="_blank"
                rel="noopener noreferrer"
                className="footer-link footer-link-external"
              >
                Upwork Profile
                <ExternalLink className="external-icon" />
              </a>
            </div>
          </div>

          <div className="footer-contact-section">
            <h4 className="footer-contact-title">Get in Touch</h4>
            <div className="footer-contact-items">
              <div className="footer-contact-item">
                <Mail className="footer-contact-icon" />
                <span>info@edsytech.com</span>
              </div>
              <div className="footer-contact-item">
                <Phone className="footer-contact-icon" />
                <span>+91 96423 00006</span>
              </div>
              <div className="footer-contact-item">
                <MapPin className="footer-contact-icon" />
                <span>Ludhiana, Punjab, IN</span>
              </div>
            </div>
          </div>
        </div>

        <div className="footer-bottom">
          <p className="footer-copyright">
            &copy; {CurrentDate.getUTCFullYear()} EDSY Tech. All rights reserved. Enterprise SaaS Architecture & Reliability Partner.
          </p>
          <div className="footer-legal">
            <a href="#" className="footer-legal-link">Privacy Policy</a>
            <a href="#" className="footer-legal-link">Terms of Service</a>
            <a href="#" className="footer-legal-link">Security</a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;